import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, OnChanges, SimpleChanges, Output, TemplateRef, ViewChild } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { CommonService } from 'src/app/services/common/common.service';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { StorageService } from 'src/app/services/storage/storage.service';


@Component({
	selector: 'app-activity-template',
	templateUrl: './activity-template.component.html',
	styleUrls: ['./activity-template.component.scss']
})
export class ActivityTemplateComponent implements OnInit, OnChanges {
	@Input() data: any;
	@Input() activity_index: any;
	@Output() activityDetailsClosed = new EventEmitter<any>();

	@Input() stepper_stage: any;
	@Input() activity_user_data: any;
	@Input() activity_action_type: any;

	@Input() coaching_plan: any;


	@Input() check_sub_taks: any;


	@Output() subTasksSelected = new EventEmitter<any>();

	@Output() newTasksSelected = new EventEmitter<any>();

	isReadOnly: boolean = false;

	user_details: any;
	user_role: any = "";

	constructor(
		public commonService: CommonService,
		private storageService: StorageService,
		private datePipe: DatePipe,
		private domSanitizer: DomSanitizer,
		private dialog: MatDialog,
	) { }

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");

		if (this.user_details.role.role == 4) {
			this.user_role = "Advisor Manager";
		} else if (this.user_details.role.role == 5) {
			this.user_role = "Advisor";
		} else if (this.user_details.role.role == 6) {
			this.user_role = "AFA";
		} else if (this.user_details.role.role == 7) {
			this.user_role = "Assistant";
		} else if (this.user_details.role.role == 8) {
			this.user_role = "Relationship Manager";
		}

		if (this.activity_action_type == "View") {
			this.isReadOnly = true;
		} else {
			this.isReadOnly = false;
		}

		if (this.data.id == null) {
			this.getActivityEmptyData();
		} else {
			this.getActivityData();
		}

		// this.getActivityData();

		this.getStatusList();
		this.getConversionStatusList();
		this.getCommunicationTypes();
		this.getTaggingUsers();

		this.getProductList();
		this.getClientProductStatus();
		this.getAttritionReasons();

		this.getStages();

		if (this.user_details.role.role != 4) {
			this.getAFA();
		}


	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['check_sub_taks'] && !changes['check_sub_taks'].isFirstChange()) {
			if (this.activity_data.task_type == 'Main Task') {
				this.getSubTasksData();
			}
		}
	}

	activity_data: any = {};
	activity_data_loaded: boolean = false;
	getActivityData() {
		this.activity_data_loaded = false;
		let route: any = "";
		if (this.data.source == 'csa') {
			route = "/clientsalesactivity/" + this.data.id + "/";
		} else if (this.data.source == 'lpa') {
			route = "/leadprospectactivity/" + this.data.id + "/";
		} else if (this.data.source == 'ama') {
			route = "/advisormanageractivity/" + this.data.id + "/";
		}
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.activity_data = res;

				if (this.activity_data.scheduled_date != "" && this.activity_data.scheduled_date != null) {
					// this.activity_data.scheduled_date = this.datePipe.transform(this.activity_data.scheduled_date, "MM/dd/yyyy");
					this.activity_data.scheduled_date = new Date(this.activity_data.scheduled_date);
				} else {
					this.activity_data.scheduled_date = "";
				}

				if (this.activity_data.actual_date != "" && this.activity_data.actual_date != null) {
					// this.activity_data.actual_date = this.datePipe.transform(this.activity_data.actual_date, "MM/dd/yyyy");
					this.activity_data.actual_date = new Date(this.activity_data.actual_date);
				} else {
					this.activity_data.actual_date = "";
				}

				if (this.activity_data.task_type == 'Main Task') {
					this.getSubTasksData();
				}

				this.activity_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	getActivityEmptyData() {
		this.activity_data_loaded = false;
		let route: any = "/emptyactivity/";
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.activity_data = res;
				this.activity_data.scheduled_date = new Date(this.activity_data.scheduled_date);
				this.activity_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	close() {
		const targetElement = document.getElementById('app-body');
		if (targetElement) {
			targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
		this.activityDetailsClosed.emit({ tyep: "Closed", index: this.activity_index });
	}

	conversion_status_list: any = [];
	getConversionStatusList() {
		this.commonService.getData('/conversionStatus/?no_page=true').subscribe(
			(res: any) => {
				this.conversion_status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	status_list: any = [];
	getStatusList() {
		this.commonService.getData('/status/?no_page=true').subscribe(
			(res: any) => {
				this.status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	communication_type_list: any = [];
	getCommunicationTypes() {
		this.commonService.getData('/communicationType/?no_page=true').subscribe(
			(res: any) => {
				this.communication_type_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	tagging_users_list: any = [];
	getTaggingUsers() {
		this.commonService.getData("/taguserslist/").subscribe(
			(res: any) => {
				this.tagging_users_list = res;
			},
			(err) => {
				this.commonService.showToast("error", err.error);
			}
		)
	}

	afa_list: any = [];
	getAFA() {
		this.commonService.getData('/getassistants').subscribe(
			(res: any) => {
				this.afa_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	product_list: any = [];
	getProductList() {
		this.commonService.getData('/product/?no_page=true&business_area=' + this.user_details.role.business_area[0]).subscribe(
			(res: any) => {
				this.product_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	client_product_status_list: any = [];
	getClientProductStatus() {
		this.commonService.getData('/clientProductStatus/?no_page=true').subscribe(
			(res: any) => {
				this.client_product_status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	attrition_reasons_list: any = [];
	getAttritionReasons() {
		// let route = '/attritionreasons?financial_institution=' + this.user_details.financial_institution + '&no_page=true' + '&business_area=' + this.user_details.role.business_area[0];
		let route = '/attritionreasons?no_page=true' + '&business_area=' + this.user_details.role.business_area[0];
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.attrition_reasons_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	getProductType(id) {
		const index = this.product_list.findIndex((x) => x.id == id);
		if (index > -1) {
			// this.product_data.product_type = this.product_list[index].product_type;
			this.product_data.product_type = this.product_list[index].product_type;
			if (this.product_list[index].product_type == 'Life Time') {
				return false;
			} else {
				return true;
			}
		} else {
			return true;
		}
	}

	stages_list: any = [];
	getStages() {
		// let route: any = '/stage?no_page=true&financial_institution=' + this.user_details.financial_institution + "&business_area=" + this.user_details.role.business_area[0];
		let route: any = '/stage?no_page=true&business_area=' + this.user_details.role.business_area[0];
		if (this.stepper_stage) {
			route = route + "&current_stage=" + this.stepper_stage.id + "&type=" + this.stepper_stage.type;
		}
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.stages_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	activity_name_copy: any = "";
	show_activity_name_options: boolean = false;
	activityNameFocus() {
		if (!this.isReadOnly) {
			this.activity_name_copy = JSON.parse(JSON.stringify(this.activity_data.name));
			this.show_activity_name_options = true;
		}
	}

	activityNameBlur() {
		this.activity_data.name = JSON.parse(JSON.stringify(this.activity_name_copy));
		setTimeout(() => {
			this.activity_name_copy = "";
		}, 100);
		this.show_activity_name_options = false;
	}

	saveActivityName() {
		if (this.activity_data.name != "" && this.activity_data.name != null) {
			this.activity_name_error = false;
			const payload = {
				id: this.activity_data.id,
				name: this.activity_data.name
			};

			this.saveActivityInformation(payload, "name");
		} else {
			this.activity_name_error = true;
		}

	}

	show_description_section: boolean = false;
	activity_description_copy: any = "";
	focusDescriptionSection() {
		if (!this.isReadOnly) {
			this.activity_description_copy = JSON.parse(JSON.stringify(this.activity_data.description));
			this.show_description_section = true;
		}
	}

	blurDescriptionSection() {
		this.show_description_section = false;
		this.activity_data.description = JSON.parse(JSON.stringify(this.activity_description_copy));
		setTimeout(() => {
			this.activity_description_copy = "";
		}, 100);
	}

	saveActivityDescription() {
		const payload = {
			id: this.activity_data.id,
			description: this.activity_data.description
		};
		this.saveActivityInformation(payload, "description");
	}

	saveActivityDirectActions(key, value, type) {
		let payload: any = {
			id: this.activity_data.id,
		};

		if (key != 'status') {
			if (type == "date") {
				payload[key] = moment(value).format();
			} else {
				payload[key] = value;
			}
		} else {
			if (value == 3) {
				if (this.activity_data.actual_date == "" || this.activity_data.actual_date == null) {
					this.activity_data.actual_date = new Date();
					payload["actual_date"] = moment(this.activity_data.actual_date).format();
				}
			}

			if (type == "date") {
				payload[key] = moment(value).format();
			} else {
				payload[key] = value;
			}
		}
		this.saveActivityInformation(payload, "");
	}


	saveActivityInformation(payload, type): any {
		if (this.data.id != null) {
			let route: any = "";
			if (this.activity_data.source == 'csa') {
				route = "/clientsalesactivity/" + payload.id + "/";
			} else if (this.activity_data.source == 'lpa') {
				route = "/leadprospectactivity/" + payload.id + "/";
			} else if (this.activity_data.source == 'ama') {
				route = "/advisormanageractivity/" + payload.id + "/";
			}

			this.commonService.patch(route, payload).subscribe(
				(res: any) => {
					if (type == "name") {
						this.activity_name_copy = "";
						this.show_activity_name_options = false;
					} else if (type == "description") {
						this.show_description_section = false;
						this.activity_description_copy = "";
					}
				},
				(err) => {
					this.commonService.showToast('error', err.error);
					return false;
				},
			);
		}
	}

	show_capture_response_section: boolean = false;
	capture_response_data_copy: any;
	showCaptureResponse() {
		this.capture_response_data_copy = JSON.parse(JSON.stringify(this.activity_data.capture_response));

		if (this.activity_data.capture_response.response_capture_date != "" && this.activity_data.capture_response.response_capture_date != null) {
			this.activity_data.capture_response.response_capture_date = this.datePipe.transform(this.activity_data.capture_response.response_capture_date, "MM/dd/yyyy")
		}

		this.show_capture_response_section = true;

		setTimeout(() => {
			const targetElement = document.getElementById('capture-response-view');
			if (targetElement) {
				targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}

		}, 100);

	}

	hideCaptureResponse() {
		this.show_capture_response_section = false;
		this.activity_data.capture_response = JSON.parse(JSON.stringify(this.capture_response_data_copy));
		setTimeout(() => {
			this.capture_response_data_copy = {};
		}, 100);
		this.capture_response_data_errors = {
			response_status: false,
			response_channel: false,
			response_capture_date: false,
			response_comments: false,
		};
	}

	capture_response_data_errors: any = {
		response_status: false,
		response_channel: false,
		response_capture_date: false,
		response_comments: false,
	};
	saveCaptureResponse() {
		if (
			this.activity_data.capture_response.response_status != '' &&
			this.activity_data.capture_response.response_status != null
		) {
			this.capture_response_data_errors.response_status = false;
		} else {
			this.capture_response_data_errors.response_status = true;
		}

		if (
			this.activity_data.capture_response.response_channel != '' &&
			this.activity_data.capture_response.response_channel != null
		) {
			this.capture_response_data_errors.response_channel = false;
		} else {
			this.capture_response_data_errors.response_channel = true;
		}

		if (
			this.activity_data.capture_response.response_capture_date != '' &&
			this.activity_data.capture_response.response_capture_date != null
		) {
			this.capture_response_data_errors.response_capture_date = false;
		} else {
			this.capture_response_data_errors.response_capture_date = true;
		}

		if (
			this.activity_data.capture_response.response_comments != '' &&
			this.activity_data.capture_response.response_comments != null
		) {
			this.capture_response_data_errors.response_comments = false;
		} else {
			this.capture_response_data_errors.response_comments = true;
		}

		if (
			this.capture_response_data_errors.response_status == false &&
			this.capture_response_data_errors.response_channel == false &&
			this.capture_response_data_errors.response_capture_date == false &&
			this.capture_response_data_errors.response_comments == false
		) {
			let payload: any = {
				response_status: this.activity_data.capture_response.response_status,
				response_channel: this.activity_data.capture_response.response_channel,
				response_capture_date: moment(this.activity_data.capture_response.response_capture_date).format(),
				response_comments: this.activity_data.capture_response.response_comments,
				// client: this.activity_user_data.id,
			};

			if (this.activity_data.source == 'csa') {
				payload.csa_id = this.activity_data.id;
			} else if (this.activity_data.source == 'lpa') {
				payload.lpa_id = this.activity_data.id;
			} else if (this.activity_data.source == 'ama') {
				payload.ama_id = this.activity_data.id;
			}

			if (this.activity_data.capture_response.captured_response == true) {
				payload.id = this.activity_data.capture_response.id;
				this.commonService.patch('/taskResponse/' + this.activity_data.capture_response.id + "/", payload).subscribe(
					(res: any) => {
						this.activity_data.capture_response = res;
						this.show_capture_response_section = false;
						this.capture_response_data_copy = {};
						this.capture_response_data_errors = {
							response_status: false,
							response_channel: false,
							response_capture_date: false,
							response_comments: false,
						};
					},
					(err) => {
						this.commonService.showToast('error', err.error);
					},
				);
			} else {
				this.commonService.postData('/taskResponse/', payload).subscribe(
					(res: any) => {
						this.activity_data.capture_response = res;
						this.show_capture_response_section = false;
						this.capture_response_data_copy = {};
						this.capture_response_data_errors = {
							response_status: false,
							response_channel: false,
							response_capture_date: false,
							response_comments: false,
						};
					},
					(err) => {
						this.commonService.showToast('error', err.error);
					},
				);
			}
		}
	}

	@ViewChild('activityEmailPreviewModal') activityEmailPreviewModal: TemplateRef<any>;
	private activityEmailPreviewModalRef: MatDialogRef<TemplateRef<any>>;
	activity_email_data: any;
	activity_email_data_loaded: boolean = false;
	openActivityEmailPreviewModal(activity) {
		if ((activity.activity_type == 1) || (activity.activity_type == 4) || (activity.activity_type == 5)) {
			this.activity_email_data_loaded = false;

			this.activityEmailPreviewModalRef = this.dialog.open(this.activityEmailPreviewModal, { disableClose: true });
			this.activityEmailPreviewModalRef.afterClosed().subscribe((result) => {
				this.closeActivityEmailPreviewModal();
			});

			this.commonService.getData("/emailTemplate/" + activity.email_template).subscribe(
				(res: any) => {
					this.activity_email_data = res;
					this.activity_email_data_loaded = true;
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}
	}

	closeActivityEmailPreviewModal() {
		this.activityEmailPreviewModalRef.close();
		this.activity_email_data = {};
		this.activity_email_data_loaded = false;
	}

	getHTML(html) {
		return this.domSanitizer.bypassSecurityTrustHtml(html);
	}

	download(link) {
		window.open(environment.apiEndpoint + '/' + link, '_blank');
	}

	// openEmail(email) {
	// 	// const email_data = JSON.parse(JSON.stringify(email));
	// 	// const parser = new DOMParser();
	// 	// const html = parser.parseFromString(email_data.email_body, 'text/html');
	// 	// window.open('mailto:' + email.email + '?subject=' + email.subject + '&body=' + encodeURIComponent(html.body.innerText), '_blank',);

	// 	const recipient = email.email;
	// 	const subject = email.subject;
	// 	const body = email.email_body;
	// 	const encodedSubject = encodeURIComponent(subject);
	// 	const encodedBody = encodeURIComponent(body);
	// 	const mailtoLink = `mailto:${recipient}?subject=${encodedSubject}&body=${encodedBody}`;
	// 	window.open(mailtoLink, '_blank');

	// }

	openEmail(email) {
		// const email_data = JSON.parse(JSON.stringify(email));
		// const parser = new DOMParser();
		// const html = parser.parseFromString(email_data.email_body, 'text/html');
		// window.open('mailto:' + email.email + '?subject=' + email.subject + '&body=' + encodeURIComponent(html.body.innerText), '_blank',);

		const recipient = email.email;
		const subject = email.subject;
		// const body = email.email_body;

		let body = email.email_body;
		const maxLength = 1250; // Example limit, adjust as needed
		body = this.convertHtmlToText(body)

		if (body.length > maxLength) {
			body = body.substring(0, maxLength) + '...';
		}

		const encodedSubject = encodeURIComponent(subject);
		const encodedBody = encodeURIComponent(body);
		const mailtoLink = `mailto:${recipient}?subject=${encodedSubject}&body=${encodedBody}`;
		window.open(mailtoLink, '_blank');

	}

	convertHtmlToText(htmlContent: string): string {
		const parser = new DOMParser();
		const doc = parser.parseFromString(htmlContent, 'text/html');

		// Extract text content and replace list items and newlines
		let textContent = doc.body.innerHTML;
		let firstParagraph = true;
		// textContent = textContent.replace(/<p class="MsoNormal"><span lang="EN-US">/g, match => {
		//   if (firstParagraph) {
		// 	firstParagraph = false;
		// 	return ''; // Replace the first occurrence with an empty string
		//   } else {
		// 	return '\n'; // Replace subsequent occurrences with a newline
		//   }
		// });

		textContent = textContent.replace(/<p[^>]*>(.*?)<\/p>/g, (match, content) => {
			content = content.trim();
			if (!content) {
				return ''; // Ignore empty paragraphs
			}

			if (firstParagraph) {
				firstParagraph = false;
				return content; // No new line for the first paragraph
			} else {
				return '\n' + content; // New line before subsequent paragraphs
			}
		});

		// Convert <li> to bullet points
		textContent = textContent.replace(/<li[^>]*>/g, '\n• ').replace(/<\/li>/g, '');
		textContent = textContent.replace(/<p[^>]*>|<br[^>]*>/g, '\n').replace(/<\/p>/g, '');

		// Remove all other HTML tags
		textContent = textContent.replace(/<[^>]+>/g, '');

		// Replace special characters for mailto link compatibility
		textContent = textContent.replace(/&#8217;/g, "'")   // Replace right single quote
			.replace(/&amp;/g, "&")    // Replace ampersand
			.replace(/&nbsp;/g, " ")   // Replace non-breaking spaces
			.replace(/%/g, '%')      // URL encode %
			.replace(/&/g, '&')      // URL encode &
			.replace(/\n\n/g, '');    // Encode newline for mailto

		textContent = textContent
			.split('\n') // Split by newlines
			.map(line => line.replace(/\s+/g, ' ').trim()) // Process each line to replace multiple spaces with single space
			.join('\n');

		return textContent
	}

	editable_field: any = "";
	toggleEditableFields(value) {
		if (this.editable_field == value) {
			this.editable_field = "";
		} else {
			this.editable_field = value;
		}
	}

	@ViewChild('activitiesDeleteModal') activitiesDeleteModal: TemplateRef<any>;
	private activitiesDeleteModalRef: MatDialogRef<TemplateRef<any>>;
	selected_activity_data: any;
	removeActivity(data) {
		this.selected_activity_data = data;
		this.activitiesDeleteModalRef = this.dialog.open(this.activitiesDeleteModal, { disableClose: true });
		this.activitiesDeleteModalRef.afterClosed().subscribe((result) => {
			this.closeDeleteActivityModal();
		});
	}

	closeDeleteActivityModal() {
		this.selected_activity_data = {};
		this.activitiesDeleteModalRef.close();
	}

	deleteActivity() {
		let route: any = "";
		if (this.user_role == "Advisor Manager") {
			route = '/advisormanageractivity/';
		} else {
			if (this.selected_activity_data.source == 'csa') {
				route = "/clientsalesactivity/";
			} else if (this.selected_activity_data.source == 'lpa') {
				route = "/leadprospectactivity/";
			}
		}
		this.commonService.delete(route + 'destroy?ids=' + this.selected_activity_data.id,).subscribe(
			(res: any) => {
				this.closeDeleteActivityModal();
				this.commonService.showToast('success', 'Activity Deleted Successfully.');
				this.close();
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	@ViewChild('automatedActivitiesOperationModal') automatedActivitiesOperationModal: TemplateRef<any>;
	private automatedActivitiesOperationModalRef: MatDialogRef<TemplateRef<any>>;

	openAutomatedActivityOperationModal() {
		this.automatedActivitiesOperationModalRef = this.dialog.open(this.automatedActivitiesOperationModal, { disableClose: true });
		this.automatedActivitiesOperationModalRef.afterClosed().subscribe((result) => {
			this.closeAutomatedActivityOperationModal();
		});
	}

	closeAutomatedActivityOperationModal() {
		this.automatedActivitiesOperationModalRef.close();
	}

	automatedActivityOperation() {
		let payload: any = {
			// client: this.selected_user_data.id,
			activity_ids: [this.activity_data.id],
			activity_paused: !this.activity_data.activity_paused
		};

		let route: any = "";
		if (this.user_role == "Advisor Manager") {
			route = "/advisormanageractivitystatuschange/";
		} else {
			if (this.activity_data.user_type == 'Prospect') {
				route = "/leadactivitystatuschange/";
			} else if (this.activity_data.user_type == 'Client') {
				route = "/clientactivitystatuschange/";
			}
		}

		this.commonService.postData(route, payload).subscribe(
			(res: any) => {
				this.activity_data.activity_paused = !this.activity_data.activity_paused;
				if (this.activity_data.activity_paused == true) {
					this.commonService.showToast('success', "Activity have been Stopped");
				} else {
					this.commonService.showToast('success', "Activity have been Resumed");
				}

				this.getActivityData();

				this.closeAutomatedActivityOperationModal();
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	sub_tasks_data: any = [];
	sub_tasks_data_loaded: boolean = false;
	getSubTasksData() {
		this.sub_tasks_data_loaded = false;
		let route: any = "";

		const activity = this.activity_data;

		if (this.user_role == "Advisor Manager") {
			route = "/advisormanageractivity/?advisor_manager=" + this.user_details.id + "&advisor=" + activity.advisor + "&parent_activity=" + activity.id + "&no_page=true&sub_task=true";

			if (this.coaching_plan) {
				route = route + "&coaching_plan=" + this.coaching_plan.id;
			}
		} else {
			if (activity.user_type == "Client") {
				route = "/clientsalesactivity?parent_activity=" + activity.id + "&advisor=" + activity.advisor + "&sub_task=true&no_page=true";
			} else if (activity.user_type == "Prospect") {
				route = "/leadprospectactivity?parent_activity=" + activity.id + "&advisor=" + activity.advisor + "&sub_task=true&no_page=true";
			}
		}

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.sub_tasks_data = res;

				this.sub_tasks_data_loaded = true;
			},
			(err) => {
				this.sub_tasks_data = [];
				this.sub_tasks_data_loaded = true;
				this.commonService.showToast('error', err.error);
			},
		);
	}

	show_add_sub_task_view: boolean = false;
	addSubTask() {
		this.show_add_sub_task_view = true;
	}

	cancelSubTask() {
		this.show_add_sub_task_view = false;
		this.sub_task_name = "";
	}

	sub_task_name: any = "";
	save_sub_task_loader: boolean = false;
	saveSubTask() {
		if (this.sub_task_name != "" && this.sub_task_name != null) {
			this.save_sub_task_loader = true;
			let route: any = "/addsubtask/";

			const activity = this.activity_data;

			let payload: any = {
				name: this.sub_task_name,
				parent_activity: activity.id,
				advisor: activity.advisor,
				activity_type: activity.activity_type,
				source: activity.source,

				status: 1,
				scheduled_date: moment(new Date()).format(),
				communication_type: 8,
			};

			if (activity.user_type == "Client") {
				payload.client = activity.client;
			} else if (activity.user_type == "Prospect") {
				payload.prospect = activity.prospect_id;
			}

			this.commonService.postData(route, payload).subscribe(
				(res: any) => {
					this.getSubTasksData();
					// this.sub_tasks_data.push(res);
					this.cancelSubTask();
					this.save_sub_task_loader = false;
				},
				(err) => {
					this.commonService.showToast('error', err.error);
					this.save_sub_task_loader = false;
				},
			);
		}
	}

	addManualSubTask() {
		// const data = {
		// 	id: null,
		// 	parent_activity: this.activity_data
		// };
		const data = {
			id: null,
			parent_activity: this.activity_data.id,
			activity_type: this.activity_data.activity_type,
			source: this.activity_data.source,
			user_type: this.activity_data.user_type,
			client: this.activity_data.client,
			prospect_id: this.activity_data.prospect_id,
			advisor: this.activity_data.advisor,
		};
		this.subTasksSelected.emit(data);
	}

	selectSubTask(data) {
		this.subTasksSelected.emit(data);
	}

	activity_tab_selected: any = "Comments";

	comment_data: any = {
		comment_date: new Date(),
		description: "",
	};
	comment_data_errors: any = {
		comment_date: false,
		description: false,
	};
	comment_operation_type: any = "";
	comment_operation_index: any = null;

	show_comments_operation_section: any = null;

	resetCommentsData() {
		this.comment_data = {
			comment_date: new Date(),
			description: "",
		};
		this.comment_data_errors = {
			comment_date: false,
			description: false,
		};
		this.comment_operation_type = "";
		this.comment_operation_index = null;
		this.show_comments_operation_section = null;
	}

	commentsOperation(data, type, index) {
		this.comment_data = JSON.parse(JSON.stringify(data));
		this.comment_operation_type = type;
		this.comment_operation_index = index;
		this.show_comments_operation_section = index;

		// if (this.comment_data.comment_date != "" && this.comment_data.comment_date != null) {
		// 	this.comment_data.comment_date = this.datePipe.transform(this.comment_data.comment_date, "MM/dd/yyyy")
		// }

		if (this.comment_data.comment_date != "" && this.comment_data.comment_date != null) {
			this.comment_data.comment_date = new Date(this.comment_data.comment_date);
		}
	}

	save_comment_loader: boolean = false;
	saveComment() {
		if (this.comment_data.comment_date != "" && this.comment_data.comment_date != null) {
			this.comment_data_errors.comment_date = false;
		} else {
			this.comment_data_errors.comment_date = true;
		}

		if (this.comment_data.description != "" && this.comment_data.description != null) {
			this.comment_data_errors.description = false;
		} else {
			this.comment_data_errors.description = true;
		}

		if (
			this.comment_data_errors.comment_date == false &&
			this.comment_data_errors.description == false
		) {
			this.save_comment_loader = true;
			let route: any = "";
			let payload: any = {
				comment_date: moment(this.comment_data.comment_date).format(),
				description: this.comment_data.description,
				commented_by: this.user_details.id
			};
			if (this.user_role == "Advisor Manager") {
				route = '/advisormanageractivitycomments/';

				payload.advisormanageradvisor_activity = this.activity_data.id;
			} else {
				if (this.activity_data.source == 'csa') {
					route = "/clientsalesactivitycomments/";
					payload.clientsales_activity = this.activity_data.id;
				} else if (this.activity_data.source == 'lpa') {
					route = "/leadprospectactivitycomments/";
					payload.prospect_activity = this.activity_data.id;
				}
			}
			// if (this.comment_operation_type == "Add") {
			if (this.show_comments_operation_section == null) {
				this.commonService.postData(route, payload).subscribe(
					(res: any) => {
						this.activity_data.comments.push(res);
						this.resetCommentsData();
						// this.commonService.showToast('success', 'Comment Added Successfully.');
						this.save_comment_loader = false;
					},
					(err) => {
						this.commonService.showToast('error', err.error);
						this.save_comment_loader = false;
					},
				);
				// } else if (this.comment_operation_type == "Edit") {
			} else if (this.show_comments_operation_section != null) {
				payload.id = this.comment_data.id;
				this.commonService.patch(route + payload.id + "/", payload).subscribe(
					(res: any) => {
						this.activity_data.comments.splice(this.comment_operation_index, 1, res);
						this.resetCommentsData();
						// this.commonService.showToast('success', 'Comment Added Successfully.');
						this.save_comment_loader = false;
					},
					(err) => {
						this.commonService.showToast('error', err.error);
						this.save_comment_loader = false;
					},
				);
			}
		}
	}

	@ViewChild('commentDeleteModal') commentDeleteModal: TemplateRef<any>;
	private commentDeleteModalRef: MatDialogRef<TemplateRef<any>>;
	removeComment(data, index) {
		this.comment_data = JSON.parse(JSON.stringify(data));
		this.comment_operation_index = index;
		this.commentDeleteModalRef = this.dialog.open(
			this.commentDeleteModal, { disableClose: true }
		);
		this.commentDeleteModalRef.afterClosed().subscribe((result) => {
			this.closeDeleteCommentModal();
		});
	}

	closeDeleteCommentModal() {
		this.commentDeleteModalRef.close();
		this.resetCommentsData();
	}

	// deleteComment(comment, index) {
	deleteComment(comment, index) {
		let route: any = "";
		if (this.user_role == "Advisor Manager") {
			route = '/advisormanageractivitycomments/';
		} else {
			if (this.activity_data.source == 'csa') {
				route = "/clientsalesactivitycomments/";
			} else if (this.activity_data.source == 'lpa') {
				route = "/leadprospectactivitycomments/";
			}
		}
		// this.commonService.delete(route + 'destroy/?ids=' + comment.id).subscribe(
		this.commonService.delete(route + 'destroy/?ids=' + this.comment_data.id).subscribe(
			(res: any) => {
				// this.activity_data.comments.splice(index, 1);
				this.activity_data.comments.splice(this.comment_operation_index, 1);
				// this.resetCommentsData();
				this.closeDeleteCommentModal();
				this.commonService.showToast('success', 'Comment Deleted Successfully.',);
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	attachment_data: any = {
		attachment_filename: "",
		attachment_file: "",
		comments: "",
	};
	attachment_data_errors: any = {
		attachment_filename: false,
		attachment_file: false,
		comments: false
	};
	attachment_operation_type: any = "";
	attachment_operation_index: any = -1;

	openAttachmentOperation(data, type, index) {
		this.attachment_data = JSON.parse(JSON.stringify(data));
		this.attachment_operation_type = type;
		this.attachment_operation_index = index;
	}

	uploadAttachment(event) {
		this.attachment_data.attachment_file = event.target.files[0];
		this.attachment_data.attachment_filename = event.target.files[0].name;
	}

	save_attachment_loader: boolean = false;
	saveAttachment() {
		if (this.attachment_data.attachment_filename != "" && this.attachment_data.attachment_filename != null) {
			this.attachment_data_errors.attachment_filename = false;
		} else {
			this.attachment_data_errors.attachment_filename = true;
		}

		if (this.attachment_data.comments != "" && this.attachment_data.comments != null) {
			this.attachment_data_errors.comments = false;
		} else {
			this.attachment_data_errors.comments = true;
		}

		if (
			this.attachment_data_errors.attachment_filename == false &&
			this.attachment_data_errors.comments == false
		) {
			this.save_attachment_loader = true;
			let form_data: any = new FormData();

			form_data.append("attachment_filename", this.attachment_data.attachment_filename);
			form_data.append("comments", this.attachment_data.comments);

			if (typeof (this.attachment_data.attachment_file) != "string") {
				form_data.append("attachment_file", this.attachment_data.attachment_file);
			}

			if (this.activity_data.source == 'csa') {
				form_data.append("csa_id", this.activity_data.id);
			} else if (this.activity_data.source == 'lpa') {
				form_data.append("lpa_id", this.activity_data.id);
			} else if (this.activity_data.source == 'ama') {
				form_data.append("ama_id", this.activity_data.id);
			}

			if (this.attachment_operation_type == 'Add') {
				this.commonService.postData("/taskAttachment/", form_data).subscribe(
					(res: any) => {
						this.activity_data.attachments.push(res);
						this.resetAttachmentData();
						// this.commonService.showToast('success', 'Attachment Added Successfully.');
						this.save_attachment_loader = false;
					},
					(err) => {
						this.commonService.showToast('error', err.error);
						this.save_attachment_loader = false;
					},
				);
			} else if (this.attachment_operation_type == 'Edit') {
				form_data.append("id", this.attachment_data.id);
				this.commonService.updateData("/taskAttachment/" + this.attachment_data.id + "/", form_data).subscribe(
					(res: any) => {
						this.activity_data.attachments.splice(this.attachment_operation_index, 1, res);
						this.resetAttachmentData();
						// this.commonService.showToast('success', 'Attachment Updated Successfully.');
						this.save_attachment_loader = false;
					},
					(err) => {
						this.commonService.showToast('error', err.error);
						this.save_attachment_loader = false;
					},
				);
			}

		}

	}

	downloadAttachment(attachment) {
		window.open(environment.apiEndpoint + "/" + attachment.attachment_download_link, "_blank");
	}

	@ViewChild('attachmentDeleteModal') attachmentDeleteModal: TemplateRef<any>;
	private attachmentDeleteModalRef: MatDialogRef<TemplateRef<any>>;
	removeAttachment(data, index) {
		this.attachment_data = JSON.parse(JSON.stringify(data));
		this.attachment_operation_index = index;
		this.attachmentDeleteModalRef = this.dialog.open(
			this.attachmentDeleteModal, { disableClose: true }
		);
		this.attachmentDeleteModalRef.afterClosed().subscribe((result) => {
			this.closeDeleteAttachmentModal();
		});
	}

	closeDeleteAttachmentModal() {
		this.attachmentDeleteModalRef.close();
		this.resetAttachmentData();
	}

	deleteAttachment() {
		this.commonService.delete("/taskAttachment/" + 'destroy?ids=' + this.attachment_data.id).subscribe(
			(res: any) => {
				this.activity_data.attachments.splice(this.attachment_operation_index, 1);
				this.closeDeleteAttachmentModal();
				// this.commonService.showToast('success', 'Attachment Deleted Successfully.');
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	resetAttachmentData() {
		this.attachment_data = {
			attachment_filename: "",
			attachment_file: "",
			comments: "",
		};
		this.attachment_data_errors = {
			attachment_filename: false,
			attachment_file: false,
			comments: false
		};
		this.attachment_operation_type = "";
		this.attachment_operation_index = -1;
	}

	// Close Deal Code
	conversion_status_data: any = {
		conversion_status: '',
		conversion_comments: '',
	};
	conversion_status_data_errors: any = {
		conversion_status: false,
		conversion_comments: false,
	};


	addProduct() {
		if (this.validateConversionStatus()) {
			if (this.conversion_status_data.conversion_status == 1) {
				if (this.user_details.role.business_area[0] == '5') {
					if (this.validateProductInformation()) {
						this.saveConversionStatusData(this.activity_data);
						// this.saveProductInformation();
					}
				}
				if (this.user_details.role.business_area[0] == '6') {
					if (this.validateDepositProductInformation()) {
						this.saveConversionStatusData(this.activity_data);
						// this.saveProductInformation();
					}
				}
			} else {
				this.saveConversionStatusData(this.activity_data);
			}
		}
	}

	resetCloseDealData() {
		this.conversion_status_data = {
			conversion_status: '',
			conversion_comments: '',
		};
		this.conversion_status_data_errors = {
			conversion_status: false,
			conversion_comments: false,
		};
		this.product_data = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
		};
		this.product_data_errors = {
			client_id: false,
			client_type: false,
			expected_aum: false,
			expected_closure_date: false,
			status: false,
			policy_number: false,
			aum: false,
			start_date: false,
			product: false,
			close_date: false,
			type: false,
			client_product_status: false,
		};
		this.product_operation_type = "Add";

		this.outcome_data = {
			attrition_status: '',
			attrition_comments: '',
		};
		this.outcome_data_errors = {
			attrition_status: false,
			attrition_comments: false,
		};
	}








	validateConversionStatus() {
		if (
			this.conversion_status_data.conversion_status != '' &&
			this.conversion_status_data.conversion_status != null
		) {
			this.conversion_status_data_errors.conversion_status = false;
		} else {
			this.conversion_status_data_errors.conversion_status = true;
		}

		if (
			this.conversion_status_data.conversion_comments != '' &&
			this.conversion_status_data.conversion_comments != null
		) {
			this.conversion_status_data_errors.conversion_comments = false;
		} else {
			this.conversion_status_data_errors.conversion_comments = true;
		}

		if (
			this.conversion_status_data_errors.conversion_status == false &&
			this.conversion_status_data_errors.conversion_comments == false
		) {
			if (this.conversion_status_data.conversion_status == 1) {
				this.validateProductInformation();
				return true;
			} else {
				return true;
			}
		} else {
			return false;
		}
	}

	saveConversionStatusData(data) {
		let payload: any = {
			conversion_status_id: this.conversion_status_data.conversion_status,
			conversion_comments: this.conversion_status_data.conversion_comments,
			client_id: this.activity_data.client,
		};

		if (!data) {
			payload.id = "";
		} else {
			if (data.source == 'csa') {
				payload.csa_id = data.id;
				payload.user_type = "Client";
			} else if (data.source == 'lpa') {
				payload.lpa_id = data.id;
				payload.user_type = "Prospect";
			} else if (data.source == 'ama') {
				payload.ama_id = data.id;
			}
		}

		// if (this.stepper_stage) {
		// 	payload.stepper_type = this.stepper_stage.type;
		// }

		this.commonService.postData('/captureclientconversionstatus/', payload).subscribe(
			(res: any) => {
				if (this.conversion_status_data.conversion_status != 1) {
					this.resetCloseDealData();
					this.resetDepositCloseDealData();
					this.close();
					this.commonService.showToast('success', 'Client moved to result stage; activities no longer visible upon deal closer',);
				} else {
					this.saveProductInformation();
				}
				// this.commonService.showToast('success','Conversion Status Changed Successfully.',);
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	product_data: any = {
		client_id: '',
		client_type: '',
		expected_aum: '',
		expected_closure_date: '',
		status: '',
		policy_number: '',
		aum: '',
		start_date: '',
		product: '',
		close_date: '',
		type: '',
		client_product_status: '',
		deposit_purpose: '',
	};
	product_data_errors: any = {
		client_id: false,
		client_type: false,
		expected_aum: false,
		expected_closure_date: false,
		status: false,
		policy_number: false,
		aum: false,
		start_date: false,
		product: false,
		close_date: false,
		type: false,
		client_product_status: false,
		deposit_purpose: false,
	};

	depositProduct_data: any = {
		client_id: '',
		client_type: '',
		expected_aum: '',
		expected_closure_date: '',
		status: '',
		policy_number: '',
		aum: '',
		start_date: '',
		product: '',
		close_date: '',
		type: '',
		client_product_status: '',
		deposit_purpose: '',
		interest_rate: '',
		monthly_fees: '',

	};
	depositProduct_data_errors: any = {
		client_id: '',
		client_type: '',
		expected_aum: '',
		expected_closure_date: '',
		status: '',
		policy_number: '',
		aum: '',
		start_date: '',
		product: '',
		close_date: '',
		type: '',
		client_product_status: '',
		deposit_purpose: '',
		interest_rate: '',
		monthly_fees: '',
	};

	depositProduct_operation_type: any = "Add";
	validateDepositProductInformation() {
		if (
			this.depositProduct_data.policy_number != '' &&
			this.depositProduct_data.policy_number != null
		) {
			this.depositProduct_data_errors.policy_number = false;
		} else {
			this.depositProduct_data_errors.policy_number = true;
		}

		if (
			this.depositProduct_data.aum != '' &&
			this.depositProduct_data.aum != null
		) {
			this.depositProduct_data_errors.aum = false;
		} else {
			this.depositProduct_data_errors.aum = true;
		}

		if (
			this.depositProduct_data.start_date != '' &&
			this.depositProduct_data.start_date != null
		) {
			this.depositProduct_data_errors.start_date = false;
		} else {
			this.depositProduct_data_errors.start_date = true;
		}

		if (
			this.depositProduct_data.product != '' &&
			this.depositProduct_data.product != null
		) {
			this.depositProduct_data_errors.product = false;
		} else {
			this.depositProduct_data_errors.product = true;
		}

		if (this.depositProduct_data.close_date != "" && this.depositProduct_data.close_date != null) {
			this.depositProduct_data_errors.close_date = false;
		} else {
			this.depositProduct_data_errors.close_date = true;
		}

		if (
			this.depositProduct_data.product_type == 'Life Time' ||
			(this.depositProduct_data.close_date != '' &&
				this.depositProduct_data.close_date != null)
		) {
			this.depositProduct_data_errors.close_date = false;
		} else {
			this.depositProduct_data_errors.close_date = true;
		}

		if (
			this.depositProduct_data.type != '' &&
			this.depositProduct_data.type != null
		) {
			this.depositProduct_data_errors.type = false;
		} else {
			this.depositProduct_data_errors.type = true;
		}


		if (
			this.depositProduct_data.interest_rate != '' &&
			this.depositProduct_data.interest_rate != null
		) {
			this.depositProduct_data_errors.interest_rate = false;
		} else {
			this.depositProduct_data_errors.interest_rate = true;
		}

		if (
			this.depositProduct_data.monthly_fees != '' &&
			this.depositProduct_data.monthly_fees != null
		) {
			this.depositProduct_data_errors.monthly_fees = false;
		} else {
			this.depositProduct_data_errors.monthly_fees = true;
		}

		if (
			this.depositProduct_data.client_product_status != '' &&
			this.depositProduct_data.client_product_status != null
		) {
			this.depositProduct_data_errors.client_product_status = false;
		} else {
			this.depositProduct_data_errors.client_product_status = true;
		}

		// if (this.user_role == "Relationship Manager") {
		// 	if (
		// 		this.depositProduct_data.deposit_purpose != '' &&
		// 		this.depositProduct_data.deposit_purpose != null
		// 	) {
		// 		this.depositProduct_data_errors.deposit_purpose = false;
		// 	} else {
		// 		this.depositProduct_data_errors.deposit_purpose = true;
		// 	}
		// }
		// else {
		// 	this.depositProduct_data.deposit_purpose = "";
		// 	this.depositProduct_data_errors.deposit_purpose = false;
		// }

		if (
			this.depositProduct_data_errors.policy_number == false &&
			this.depositProduct_data_errors.aum == false &&
			this.depositProduct_data_errors.start_date == false &&
			this.depositProduct_data_errors.product == false &&
			this.depositProduct_data_errors.close_date == false &&
			this.depositProduct_data_errors.type == false &&
			this.depositProduct_data_errors.client_product_status == false &&
			this.depositProduct_data_errors.interest_rate == false &&
			this.depositProduct_data_errors.monthly_fees == false &&
			this.min_amount_error == false
			// this.depositProduct_data_errors.deposit_purpose == false
		) {
			return true;
		} else {
			return false;
		}
	}


	resetDepositCloseDealData() {
		this.conversion_status_data = {
			conversion_status: '',
			conversion_comments: '',
		};
		this.conversion_status_data_errors = {
			conversion_status: false,
			conversion_comments: false,
		};
		this.depositProduct_data = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',

		};
		this.depositProduct_data_errors = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',
		};
		this.depositProduct_operation_type = "Add";

		this.outcome_data = {
			attrition_status: '',
			attrition_comments: '',
		};
		this.outcome_data_errors = {
			attrition_status: false,
			attrition_comments: false,
		};
	}

	product_operation_type: any = "Add";
	validateProductInformation() {
		if (
			this.product_data.policy_number != '' &&
			this.product_data.policy_number != null
		) {
			this.product_data_errors.policy_number = false;
		} else {
			this.product_data_errors.policy_number = true;
		}

		if (
			this.product_data.aum != '' &&
			this.product_data.aum != null
		) {
			this.product_data_errors.aum = false;
		} else {
			this.product_data_errors.aum = true;
		}

		if (
			this.product_data.start_date != '' &&
			this.product_data.start_date != null
		) {
			this.product_data_errors.start_date = false;
		} else {
			this.product_data_errors.start_date = true;
		}

		if (
			this.product_data.product != '' &&
			this.product_data.product != null
		) {
			this.product_data_errors.product = false;
		} else {
			this.product_data_errors.product = true;
		}

		// if (this.product_data.close_date != "" && this.product_data.close_date != null) {
		//   this.product_data_errors.close_date = false;
		// } else {
		//   this.product_data_errors.close_date = true;
		// }

		if (
			this.product_data.product_type == 'Life Time' ||
			(this.product_data.close_date != '' &&
				this.product_data.close_date != null)
		) {
			this.product_data_errors.close_date = false;
		} else {
			this.product_data_errors.close_date = true;
		}

		if (
			this.product_data.type != '' &&
			this.product_data.type != null
		) {
			this.product_data_errors.type = false;
		} else {
			this.product_data_errors.type = true;
		}

		if (
			this.product_data.client_product_status != '' &&
			this.product_data.client_product_status != null
		) {
			this.product_data_errors.client_product_status = false;
		} else {
			this.product_data_errors.client_product_status = true;
		}

		if (this.user_role == "Relationship Manager") {
			if (
				this.product_data.deposit_purpose != '' &&
				this.product_data.deposit_purpose != null
			) {
				this.product_data_errors.deposit_purpose = false;
			} else {
				this.product_data_errors.deposit_purpose = true;
			}
		} else {
			this.product_data.deposit_purpose = "";
			this.product_data_errors.deposit_purpose = false;
		}

		if (
			this.product_data_errors.policy_number == false &&
			this.product_data_errors.aum == false &&
			this.product_data_errors.start_date == false &&
			this.product_data_errors.product == false &&
			this.product_data_errors.close_date == false &&
			this.product_data_errors.type == false &&
			this.product_data_errors.client_product_status == false &&
			this.product_data_errors.deposit_purpose == false
		) {
			return true;
		} else {
			return false;
		}
	}

	saveProductInformation() {
		let payload: any;
		if (this.user_details.role.business_area[0] == '5')
			payload = {
				product: this.product_data.product,
				policy_number: this.product_data.policy_number,
				aum: this.product_data.aum == '' ? 0 : this.product_data.aum,
				start_date: moment(this.product_data.start_date).format(),
				close_date: this.product_data.close_date != '' ? moment(this.product_data.close_date).format() : null,
				// client: this.selected_user_data.id,
				// client: this.activities[this.show_inner_view].client,
				type: this.product_data.type,
				deposit_purpose: this.product_data.deposit_purpose,
			};

		if (this.user_details.role.business_area[0] == '6')
			payload = {
				product: this.depositProduct_data.product,
				policy_number: this.depositProduct_data.policy_number,
				aum: this.depositProduct_data.aum == '' ? 0 : this.depositProduct_data.aum,
				start_date: moment(this.depositProduct_data.start_date).format(),
				close_date: this.depositProduct_data.close_date != '' ? moment(this.depositProduct_data.close_date).format() : null,
				// client: this.selected_user_data.id,
				// client: this.activities[this.show_inner_view].client,
				type: this.depositProduct_data.type,
				deposit_purpose: this.depositProduct_data.deposit_purpose,
				interest_rate: this.depositProduct_data.interest_rate,
				monthly_fees: this.depositProduct_data.monthly_fees,

			};

		if (this.stepper_stage) {
			payload.stepper_type = this.stepper_stage.type;
		} else {
			payload.stepper_type = this.data.type;
		}

		if (this.product_operation_type == "Add" || this.depositProduct_operation_type == "Add") {
			let route: any = "";
			if (this.activity_data) {
				if (this.activity_data.source == 'csa') {
					route = "/addclientinvestedproducts/";
					payload.client = this.activity_data.client;
				} else if (this.activity_data.source == 'lpa') {
					route = "/addprospectinvestedproducts/";
					payload.prospect = this.activity_data.prospect_id;
				}
			} else {
				if ('is_client' in this.activity_data) {
					route = "/addprospectinvestedproducts/";
					payload.prospect = this.activity_data.prospect_id;
				} else {
					route = "/addclientinvestedproducts/";
					payload.client = this.activity_data.client;
				}
			}
			this.commonService.postData(route, payload).subscribe(
				(res: any) => {
					this.resetCloseDealData();
					this.resetDepositCloseDealData();
					this.close();
					// this.commonService.showToast('success', 'Product Added Successfully.',);
					this.commonService.showToast('success', 'Client moved to result stage; activities no longer visible upon deal closer',);
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}



		else if (this.product_operation_type == "Edit" || this.depositProduct_data == "Edit") {
			if (this.user_details.role.business_area[0] == '5') {
				payload.id = this.product_data.id;
			}
			else if (this.user_details.role.business_area[0] == '6') {
				payload.id = this.depositProduct_data.id;
			}
			let route: any = "";
			if (this.activity_data.source == 'csa') {
				route = "/clientproducts/";
			} else if (this.activity_data.source == 'lpa') {
				route = "/prospectinvestedproducts/";
			}
			this.commonService.updateData(route + payload.id + '/', payload).subscribe(
				(res: any) => {
					this.resetCloseDealData();
					this.resetDepositCloseDealData();
					this.close();
					// this.commonService.showToast('success', 'Product Updated Successfully.', );
					this.commonService.showToast('success', 'Client moved to result stage; activities no longer visible upon deal closer',);
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}
	}

	// Change Outcome Code
	outcome_data: any = {
		attrition_status: '',
		attrition_comments: '',
	};
	outcome_data_errors: any = {
		attrition_status: false,
		attrition_comments: false,
	};

	validateOutcomeStatus() {
		if (
			this.outcome_data.attrition_status != '' &&
			this.outcome_data.attrition_status != null
		) {
			this.outcome_data_errors.attrition_status = false;
		} else {
			this.outcome_data_errors.attrition_status = true;
		}

		if (
			this.outcome_data.attrition_comments != '' &&
			this.outcome_data.attrition_comments != null
		) {
			this.outcome_data_errors.attrition_comments = false;
		} else {
			this.outcome_data_errors.attrition_comments = true;
		}

		if (
			this.outcome_data_errors.attrition_status == false &&
			this.outcome_data_errors.attrition_comments == false
		) {
			if (this.outcome_data.attrition_status == 'Retained, Upside') {
				this.validateProductInformation();
				return true;
			} else {
				return true;
			}
		} else {
			return false;
		}
	}

	saveOutcomeStatusData(data) {
		let payload: any = {
			attrition_status: this.outcome_data.attrition_status,
			attrition_comments: this.outcome_data.attrition_comments,
			// client_id: this.selected_user_data.id,
			client_id: this.activity_data.client,
		};

		if (!data) {
			payload.id = "";
		} else {
			if (data.source == 'csa') {
				payload.csa_id = data.id;
			} else if (data.source == 'lpa') {
				payload.lpa_id = data.id;
			} else if (data.source == 'ama') {
				payload.ama_id = data.id;
			}
		}

		// if (this.stepper_stage) {
		// 	payload.stepper_type = this.stepper_stage.type;
		// }

		this.commonService.postData('/clientattritionoutcome/', payload).subscribe(
			(res: any) => {
				if (this.outcome_data.attrition_status != 'Retained, Upside') {
					this.resetCloseDealData();
					this.resetDepositCloseDealData();
					this.close();
					this.commonService.showToast('success', 'Client moved to result stage; activities no longer visible upon deal closer',);
				} else {
					this.saveProductInformation();
				}
				// this.commonService.showToast('success', 'Outcome Changed Successfully.',);
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}


	addOutcome() {
		if (this.validateOutcomeStatus()) {
			if (this.outcome_data.attrition_status == 'Retained, Upside') {
				if (this.validateProductInformation()) {
					this.saveOutcomeStatusData(this.activity_data);
					// this.saveProductInformation();
				}
			} else {
				this.saveOutcomeStatusData(this.activity_data);
			}
		}
	}

	show_attachments_view: boolean = false;
	showAttachmentsView() {
		this.show_attachments_view = true;
		this.resetAttachmentData();
		setTimeout(() => {
			const targetElement = document.getElementById('attachments-view');
			if (targetElement) {
				targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}

		}, 100);
	}

	hideAttachmentsView() {
		this.show_attachments_view = false;
		this.resetAttachmentData();
	}

	show_close_deal_view: boolean = false;
	showCloseDealView() {
		this.show_close_deal_view = true;
		this.resetCloseDealData();
		this.resetDepositCloseDealData();
		setTimeout(() => {
			const targetElement = document.getElementById('close-deal-view');
			if (targetElement) {
				targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}

		}, 100);
	}

	hideCloseDealView() {
		this.show_close_deal_view = false;
		if (this.user_details.role.business_area[0] == '5') {
			this.resetCloseDealData();
		}
		if (this.user_details.role.business_area[0] == '6') {
			this.resetDepositCloseDealData();
		}
	}

	show_change_outcome_view: boolean = false;
	showChangeOutcomeView() {
		this.show_change_outcome_view = true;
		this.resetCloseDealData();
		this.resetDepositCloseDealData();
		setTimeout(() => {
			const targetElement = document.getElementById('change-outcome-view');
			if (targetElement) {
				targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}

		}, 100);
	}

	hideChangeOutcomeView() {
		this.show_change_outcome_view = false;
		this.resetCloseDealData();
		this.resetDepositCloseDealData();
	}

	numberOnly(event): boolean {
		const charCode = event.which ? event.which : event.keyCode;
		if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
	}

	@ViewChild('notificationModal') notificationModal: TemplateRef<any>;
	private notificationModalRef: MatDialogRef<TemplateRef<any>>;

	notification_data: any = {
		campaign_channel: "",
		campaign_content: "",
		campaign_date: new Date()
	};
	notification_data_errors: any = {
		campaign_channel: false,
		campaign_content: false,
		campaign_date: false
	};
	openNotificationModal(type, content) {
		this.notification_data.campaign_channel = JSON.parse(JSON.stringify(type));
		this.notification_data.campaign_content = JSON.parse(JSON.stringify(content));
		this.notification_data.campaign_date = new Date();
		this.notificationModalRef = this.dialog.open(
			this.notificationModal, { disableClose: true }
		);
		this.notificationModalRef.afterClosed().subscribe((result) => {
			this.closeNotificationModal();
		});
	}

	closeNotificationModal() {
		this.notificationModalRef.close();
		this.resetNotificationData();
	}

	sendNotification() {
		if (this.notification_data.campaign_channel != "" && this.notification_data.campaign_channel != null) {
			this.notification_data_errors.campaign_channel = false;
		} else {
			this.notification_data_errors.campaign_channel = true;
		}

		if (this.notification_data.campaign_content != "" && this.notification_data.campaign_content != null) {
			this.notification_data_errors.campaign_content = false;
		} else {
			this.notification_data_errors.campaign_content = true;
		}

		if (this.notification_data.campaign_date != "" && this.notification_data.campaign_date != null) {
			this.notification_data_errors.campaign_date = false;
		} else {
			this.notification_data_errors.campaign_date = true;
		}

		if (
			this.notification_data_errors.campaign_channel == false &&
			this.notification_data_errors.campaign_content == false &&
			this.notification_data_errors.campaign_date == false
		) {
			let payload: any = {
				campaign_channel: this.notification_data.campaign_channel,
				campaign_content: this.notification_data.campaign_content,
				campaign_date: moment(this.notification_data.campaign_date).format(),
			};

			if (this.activity_data.source == 'csa') {
				payload.csa_id = this.activity_data.id;
			} else if (this.activity_data.source == 'lpa') {
				payload.lpa_id = this.activity_data.id;
			} else if (this.activity_data.source == 'ama') {
				payload.ama_id = this.activity_data.id;
			}

			this.commonService.postData("/campaignHistory/", payload).subscribe(
				(res: any) => {
					this.getActivityData();
					this.closeNotificationModal();
					this.commonService.showToast('success', "Campaign has been sent.");
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}
	}

	resetNotificationData() {
		this.notification_data = {
			campaign_channel: "",
			campaign_content: "",
			campaign_date: new Date()
		};
		this.notification_data_errors = {
			campaign_channel: false,
			campaign_content: false,
			campaign_date: false
		};
	}

	activity_name_error: boolean = false;
	activity_status_error: boolean = false;
	activity_assignee_error: boolean = false;
	activity_schedule_date_error: boolean = false;
	activity_channel_error: boolean = false;
	saveActivityData() {

		if (this.activity_data.name != "" && this.activity_data.name != null) {
			this.activity_name_error = false;
		} else {
			this.activity_name_error = true;
		}

		if (this.activity_data.status != "" && this.activity_data.status != null) {
			this.activity_status_error = false;
		} else {
			this.activity_status_error = true;
		}

		if (this.user_role != 'Advisor Manager') {
			if (this.activity_data.afa_id != null) {
				this.activity_assignee_error = false;
			} else {
				this.activity_assignee_error = true;
			}
		} else {
			this.activity_assignee_error = false;
		}

		if (this.activity_data.scheduled_date != "" && this.activity_data.scheduled_date != null) {
			this.activity_schedule_date_error = false;
		} else {
			this.activity_schedule_date_error = true;
		}

		if (this.activity_data.communication_type != "" && this.activity_data.communication_type != null) {
			this.activity_channel_error = false;
		} else {
			this.activity_channel_error = true;
		}

		if (
			this.activity_name_error == false &&
			this.activity_status_error == false &&
			this.activity_assignee_error == false &&
			this.activity_schedule_date_error == false &&
			this.activity_channel_error == false
		) {
			if (this.activity_data.id == null) {
				let payload: any = {
					name: this.activity_data.name,
					// status: 1,
					status: this.activity_data.status,
					// afa_id: this.activity_data.afa_id,
					scheduled_date: moment(this.activity_data.scheduled_date).format(),
					communication_type: this.activity_data.communication_type,
					description: this.activity_data.description,
				};

				if (this.user_role != 'Advisor Manager') {
					payload.afa_id = this.activity_data.afa_id;
				}

				if (this.activity_data.actual_date != "" && this.activity_data.actual_date != null) {
					payload.actual_date = moment(this.activity_data.actual_date).format();
				}

				if (this.data.activity_type == 1) {
					payload.activity_type = 2;
				} else if (this.data.activity_type == 5) {
					payload.activity_type = 3;
				} else {
					payload.activity_type = this.data.activity_type;
				}

				if (this.data.parent_activity != null) {
					payload.parent_activity = this.data.parent_activity;
					payload.source = this.data.source;
				}

				let route: any = "";
				if (this.data.parent_activity != null) {
					route = "/addsubtask/";
					if (this.user_role != 'Advisor Manager') {
						payload.advisor = this.user_details.id;
						if (this.data.user_type == "Client") {
							payload.client = this.data.client;
						} else if (this.data.user_type == "Prospect") {
							payload.prospect = this.data.prospect_id;
						}
					} else {
						payload.advisor_manager = this.user_details.id;
						payload.advisor = this.data.advisor;
					}
					// if (this.data.source == 'csa') {
					// 	// route = "/clientsalesactivity/";
					// 	payload.client = this.data.client;
					// 	payload.advisor = this.user_details.id;
					// } else if (this.data.source == 'lpa') {
					// 	// route = "/leadprospectactivity/";
					// 	payload.prospect = this.data.prospect;
					// 	payload.advisor = this.user_details.id;
					// } else if (this.data.source == 'ama') {

					// }
				} else {
					if (this.user_role != 'Advisor Manager') {
						if ('is_client' in this.activity_user_data) {
							route = "/leadprospectactivity/";
							payload.prospect = this.activity_user_data.id;
							payload.advisor = this.user_details.id;
						} else {
							route = "/clientsalesactivity/";
							payload.client = this.activity_user_data.id;
							payload.advisor = this.user_details.id;
						}
					} else {
						route = "/advisormanageractivity/";
						payload.advisor = this.activity_user_data.id;
						payload.advisor_manager = this.user_details.id;
					}
				}

				this.commonService.postData(route, payload).subscribe(
					(res: any) => {
						this.activity_data = res;
						if (this.activity_data.task_type == 'Main Task') {
							this.newTasksSelected.emit({ data: this.activity_data, index: this.activity_index });
						} else {
							// this.close();
							if (this.activity_data.communication_type == 10) {
								this.newTasksSelected.emit({ data: this.activity_data, index: this.activity_index });
							} else {
								this.close();
							}
						}
						this.commonService.showToast('success', "Activity Saved Successfully.");
					},
					(err) => {
						this.commonService.showToast('error', err.error);
					},
				);
			} else {
				let route: any = "";
				// let payload: any = JSON.parse(JSON.stringify(this.activity_data));

				let payload: any = {
					id: this.activity_data.id,
					name: this.activity_data.name,
					status: this.activity_data.status,
					// afa_id: this.activity_data.afa_id,
					scheduled_date: moment(this.activity_data.scheduled_date).format(),
					communication_type: this.activity_data.communication_type,
					description: this.activity_data.description,
				};

				if (this.user_role != 'Advisor Manager') {
					payload.afa_id = this.activity_data.afa_id;
				}

				if (this.activity_data.actual_date != "" && this.activity_data.actual_date != null) {
					payload.actual_date = moment(this.activity_data.actual_date).format();
				}

				if (this.user_role != 'Advisor Manager') {
					payload.advisor = this.user_details.id;
					if (this.activity_data.user_type == "Client") {
						payload.client = this.activity_data.client;
					} else if (this.activity_data.user_type == "Prospect") {
						payload.prospect = this.activity_data.prospect_id;
					}
				} else {
					payload.advisor = this.activity_data.advisor;
					payload.advisor_manager = this.user_details.id;
				}

				if (this.activity_data.source == 'csa') {
					route = "/clientsalesactivity/" + payload.id + "/";
				} else if (this.activity_data.source == 'lpa') {
					route = "/leadprospectactivity/" + payload.id + "/";
				} else if (this.activity_data.source == 'ama') {
					route = "/advisormanageractivity/" + payload.id + "/";
				}

				this.commonService.patch(route, payload).subscribe(
					(res: any) => {
						this.commonService.showToast('success', "Activity Saved Successfully.");
					},
					(err) => {
						this.commonService.showToast('error', err.error);
						return false;
					},
				);
			}
		}
	}

	@ViewChild('scheduleMeetingModal') scheduleMeetingModal: TemplateRef<any>;
	private scheduleMeetingModalRef: MatDialogRef<TemplateRef<any>>;
	openScheduleMeetingModal() {
		this.generateTimeSlots();
		this.generateDurationSlots();
		this.generateTimeZones();

		this.scheduleMeetingModalRef = this.dialog.open(
			this.scheduleMeetingModal, { disableClose: true }
		);
		this.scheduleMeetingModalRef.afterClosed().subscribe((result) => {
			this.closeScheduleMeetingModal();
		});
	}

	closeScheduleMeetingModal() {
		this.scheduleMeetingModalRef.close();
		this.meeting_data = {
			topic: "",
			description: "",
			when: new Date(),
			time: "",
			duration: "",
			timezone: "",
			attendees: [],
			attachments: [],
		};
		this.meeting_data_errors = {
			topic: false,
			description: false,
			when: false,
			time: false,
			duration: false,
			timezone: false,
			attendees: false,
			attachments: false,
		};
	}

	meeting_data: any = {
		topic: "",
		description: "",
		when: new Date(),
		time: "",
		duration: "",
		timezone: "",
		attendees: [],
		attachments: [],
	};
	meeting_data_errors: any = {
		topic: false,
		description: false,
		when: false,
		time: false,
		duration: false,
		timezone: false,
		attendees: false,
		attachments: false,
	};

	@ViewChild('meetingAtachmentFile') meetingAtachmentFile;
	uploadAtatchmentFile(event) {
		for (let index = 0; index < event.target.files.length; index++) {
			this.meeting_data.attachments.push({
				name: event.target.files[index].name,
				file: event.target.files[index]
			});
		}
		this.meetingAtachmentFile.nativeElement.value = '';
	}

	deleteAttachmentFile(index) {
		this.meeting_data.attachments.splice(index, 1);
	}

	separatorKeysCodes: number[] = [ENTER, COMMA];
	attendees_error: boolean = false;

	addAtteendeeEmail(event: any): void {
		const input = event.input;
		const value = event.value.trim();

		// Email validation regex
		const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

		if (value && emailPattern.test(value)) {
			this.meeting_data.attendees.push(value);
			this.attendees_error = false;
		} else if (value) {
			this.attendees_error = true;
		}

		// Reset the input value
		if (input) {
			input.value = '';
		}
	}

	removeAtteendeeEmail(email: string): void {
		const index = this.meeting_data.attendees.indexOf(email);

		if (index >= 0) {
			this.meeting_data.attendees.splice(index, 1);
		}
	}

	scheduleMeeting() {
		if (this.meeting_data.topic != "" && this.meeting_data.topic != null) {
			this.meeting_data_errors.topic = false;
		} else {
			this.meeting_data_errors.topic = true;
		}

		if (this.meeting_data.description != "" && this.meeting_data.description != null) {
			this.meeting_data_errors.description = false;
		} else {
			this.meeting_data_errors.description = true;
		}

		if (this.meeting_data.when != "" && this.meeting_data.when != null) {
			this.meeting_data_errors.when = false;
		} else {
			this.meeting_data_errors.when = true;
		}

		if (this.meeting_data.time != "" && this.meeting_data.time != null) {
			this.meeting_data_errors.time = false;
		} else {
			this.meeting_data_errors.time = true;
		}

		if (this.meeting_data.duration != "" && this.meeting_data.duration != null) {
			this.meeting_data_errors.duration = false;
		} else {
			this.meeting_data_errors.duration = true;
		}

		if (this.meeting_data.timezone != "" && this.meeting_data.timezone != null) {
			this.meeting_data_errors.timezone = false;
		} else {
			this.meeting_data_errors.timezone = true;
		}

		if (
			this.meeting_data_errors.topic == false &&
			this.meeting_data_errors.description == false &&
			this.meeting_data_errors.when == false &&
			this.meeting_data_errors.time == false &&
			this.meeting_data_errors.duration == false &&
			this.meeting_data_errors.timezone == false
		) {
			let route: any = "/schedulezoommeeting/";

			let payload: any = {
				topic: this.meeting_data.topic,
				description: this.meeting_data.description,
				duration: this.meeting_data.duration,
				start_date: moment(this.meeting_data.when).format("YYYY-MM-DD"),
				start_time_full: this.meeting_data.time,
				timezone: this.meeting_data.timezone,
				activity_id: this.activity_data.id,
				source: this.activity_data.source,
			};

			const formData = new FormData();
			formData.append('topic', this.meeting_data.topic);
			formData.append('description', this.meeting_data.description);
			formData.append('duration', this.meeting_data.duration);
			formData.append('start_date', moment(this.meeting_data.when).format("YYYY-MM-DD"));
			formData.append('start_time_full', this.meeting_data.time);
			formData.append('timezone', this.meeting_data.timezone);
			formData.append('activity_id', this.activity_data.id);
			formData.append('source', this.activity_data.source);

			formData.append('files_count', this.meeting_data.attachments.length);
			formData.append('attendees', this.meeting_data.attendees);

			if (this.meeting_data.attachments.length > 0) {
				for (let index = 0; index < this.meeting_data.attachments.length; index++) {
					const key = "attachment_file_" + (index + 1);
					formData.append(key, this.meeting_data.attachments[index].file);
				}
			}

			this.commonService.postData(route, formData).subscribe(
				(res: any) => {
					this.closeScheduleMeetingModal();
					this.getActivityData();
					this.commonService.showToast('success', 'Meeting has been scheduled successfully. A confirmation email has been sent to the client, and meeting details have been recorded in the comments section.');
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}

	}

	time_slots: any = [];
	generateTimeSlots() {
		const now = new Date();
		const start = new Date(this.meeting_data.when);
		start.setHours(0, 0, 0, 0);  // Set to midnight
		const end = new Date(start);
		end.setDate(end.getDate() + 1);  // End at midnight of the next day

		this.time_slots = [];  // Ensure the time_slots array is empty before generating new slots

		while (start < end) {
			if (start > now) {  // Only add future time slots
				const hours = start.getHours();
				const minutes = start.getMinutes();
				const ampm = hours >= 12 ? 'PM' : 'AM';
				const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
				const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
				this.time_slots.push(`${formattedHours}:${formattedMinutes} ${ampm}`);
			}
			start.setMinutes(start.getMinutes() + 15);
		}
	}

	duration_slots: any = [];
	generateDurationSlots() {
		const totalMinutesInDay = 24 * 60;
		const interval = 15; // 15-minute intervals

		this.duration_slots = []; // Ensure the duration_slots array is empty before generating new slots

		for (let minutes = interval; minutes <= totalMinutesInDay; minutes += interval) {
			const hours = Math.floor(minutes / 60);
			const remainingMinutes = minutes % 60;
			let duration = '';

			if (hours > 0) {
				duration += `${hours} hour${hours > 1 ? 's' : ''}`;
			}

			if (remainingMinutes > 0) {
				if (hours > 0) {
					duration += ' ';
				}
				duration += `${remainingMinutes} minute${remainingMinutes > 1 ? 's' : ''}`;
			}

			this.duration_slots.push({ name: duration, value: minutes });
		}
	}

	// timezone_list_old: any = [
	// 	'(GMT -11:00) Pacific/Midway',
	// 	'(GMT -10:00) Pacific/Honolulu',
	// 	'(GMT -09:00) America/Juneau',
	// 	'(GMT -08:00) America/Los_Angeles',
	// 	'(GMT -07:00) America/Denver',
	// 	'(GMT -06:00) America/Chicago',
	// 	'(GMT -05:00) America/New_York',
	// 	'(GMT -04:00) America/Halifax',
	// 	'(GMT -03:30) America/St_Johns',
	// 	'(GMT -03:00) America/Argentina/Buenos_Aires',
	// 	'(GMT -02:00) Atlantic/South_Georgia',
	// 	'(GMT -01:00) Atlantic/Azores',
	// 	'(GMT +00:00) Europe/London',
	// 	'(GMT +01:00) Europe/Paris',
	// 	'(GMT +02:00) Europe/Athens',
	// 	'(GMT +03:00) Europe/Moscow',
	// 	'(GMT +03:30) Asia/Tehran',
	// 	'(GMT +04:00) Asia/Dubai',
	// 	'(GMT +04:30) Asia/Kabul',
	// 	'(GMT +05:00) Asia/Karachi',
	// 	'(GMT +05:30) Asia/Kolkata',
	// 	'(GMT +05:45) Asia/Kathmandu',
	// 	'(GMT +06:00) Asia/Dhaka',
	// 	'(GMT +06:30) Asia/Yangon',
	// 	'(GMT +07:00) Asia/Bangkok',
	// 	'(GMT +08:00) Asia/Shanghai',
	// 	'(GMT +09:00) Asia/Tokyo',
	// 	'(GMT +09:30) Australia/Adelaide',
	// 	'(GMT +10:00) Australia/Sydney',
	// 	'(GMT +11:00) Pacific/Guam',
	// 	'(GMT +12:00) Pacific/Auckland',
	// 	'(GMT +13:00) Pacific/Tongatapu'
	// ];

	timezone_list: any = [];
	generateTimeZones() {
		const timeZonesObject = {
			"Pacific/Midway": "(GMT-11:00) Midway Island, Samoa",
			"Pacific/Pago_Pago": "(GMT-11:00) Pago Pago",
			"Pacific/Honolulu": "(GMT-10:00) Hawaii",
			"America/Anchorage": "(GMT-8:00) Alaska",
			"America/Juneau": "(GMT-8:00) Juneau",
			"America/Vancouver": "(GMT-7:00) Vancouver",
			"America/Los_Angeles": "(GMT-7:00) Pacific Time (US and Canada)",
			"America/Tijuana": "(GMT-7:00) Tijuana",
			"America/Phoenix": "(GMT-7:00) Arizona",
			"America/Edmonton": "(GMT-6:00) Edmonton",
			"America/Denver": "(GMT-6:00) Mountain Time (US and Canada)",
			"America/Mazatlan": "(GMT-6:00) Mazatlan",
			"America/Regina": "(GMT-6:00) Saskatchewan",
			"America/Guatemala": "(GMT-6:00) Guatemala",
			"America/El_Salvador": "(GMT-6:00) El Salvador",
			"America/Managua": "(GMT-6:00) Managua",
			"America/Costa_Rica": "(GMT-6:00) Costa Rica",
			"America/Tegucigalpa": "(GMT-6:00) Tegucigalpa",
			"America/Chihuahua": "(GMT-6:00) Chihuahua",
			"America/Winnipeg": "(GMT-5:00) Winnipeg",
			"America/Chicago": "(GMT-5:00) Central Time (US and Canada)",
			"America/Mexico_City": "(GMT-5:00) Mexico City",
			"America/Panama": "(GMT-5:00) Panama",
			"America/Bogota": "(GMT-5:00) Bogota",
			"America/Lima": "(GMT-5:00) Lima",
			"America/Monterrey": "(GMT-5:00) Monterrey",
			"America/Montreal": "(GMT-4:00) Montreal",
			"America/New_York": "(GMT-4:00) Eastern Time (US and Canada)",
			"America/Indianapolis": "(GMT-4:00) Indiana (East)",
			"America/Puerto_Rico": "(GMT-4:00) Puerto Rico",
			"America/Caracas": "(GMT-4:00) Caracas",
			"America/Santiago": "(GMT-4:00) Santiago",
			"America/La_Paz": "(GMT-4:00) La Paz",
			"America/Guyana": "(GMT-4:00) Guyana",
			"America/Halifax": "(GMT-3:00) Halifax",
			"America/Montevideo": "(GMT-3:00) Montevideo",
			"America/Araguaina": "(GMT-3:00) Recife",
			"America/Argentina/Buenos_Aires": "(GMT-3:00) Buenos Aires, Georgetown",
			"America/Sao_Paulo": "(GMT-3:00) Sao Paulo",
			"Canada/Atlantic": "(GMT-3:00) Atlantic Time (Canada)",
			"America/St_Johns": "(GMT-2:30) Newfoundland and Labrador",
			"America/Godthab": "(GMT-2:00) Greenland",
			"Atlantic/Cape_Verde": "(GMT-1:00) Cape Verde Islands",
			"Atlantic/Azores": "(GMT+0:00) Azores",
			"UTC": "(GMT+0:00) Universal Time UTC",
			"Etc/Greenwich": "(GMT+0:00) Greenwich Mean Time",
			"Atlantic/Reykjavik": "(GMT+0:00) Reykjavik",
			"Africa/Casablanca": "(GMT+0:00) Casablanca",
			"Africa/Nouakchott": "(GMT+0:00) Nouakchott",
			"Europe/Dublin": "(GMT+1:00) Dublin",
			"Europe/London": "(GMT+1:00) London",
			"Europe/Lisbon": "(GMT+1:00) Lisbon",
			"Africa/Bangui": "(GMT+1:00) West Central Africa",
			"Africa/Algiers": "(GMT+1:00) Algiers",
			"Africa/Tunis": "(GMT+1:00) Tunis",
			"Europe/Belgrade": "(GMT+2:00) Belgrade, Bratislava, Ljubljana",
			"CET": "(GMT+2:00) Sarajevo, Skopje, Zagreb",
			"Europe/Oslo": "(GMT+2:00) Oslo",
			"Europe/Copenhagen": "(GMT+2:00) Copenhagen",
			"Europe/Brussels": "(GMT+2:00) Brussels",
			"Europe/Berlin": "(GMT+2:00) Amsterdam, Berlin, Rome, Stockholm, Vienna",
			"Europe/Amsterdam": "(GMT+2:00) Amsterdam",
			"Europe/Rome": "(GMT+2:00) Rome",
			"Europe/Stockholm": "(GMT+2:00) Stockholm",
			"Europe/Vienna": "(GMT+2:00) Vienna",
			"Europe/Luxembourg": "(GMT+2:00) Luxembourg",
			"Europe/Paris": "(GMT+2:00) Paris",
			"Europe/Zurich": "(GMT+2:00) Zurich",
			"Europe/Madrid": "(GMT+2:00) Madrid",
			"Africa/Harare": "(GMT+2:00) Harare, Pretoria",
			"Europe/Warsaw": "(GMT+2:00) Warsaw",
			"Europe/Prague": "(GMT+2:00) Prague Bratislava",
			"Europe/Budapest": "(GMT+2:00) Budapest",
			"Africa/Tripoli": "(GMT+2:00) Tripoli",
			"Africa/Cairo": "(GMT+2:00) Cairo",
			"Africa/Johannesburg": "(GMT+2:00) Johannesburg",
			"Africa/Khartoum": "(GMT+2:00) Khartoum",
			"Europe/Helsinki": "(GMT+3:00) Helsinki",
			"Africa/Nairobi": "(GMT+3:00) Nairobi",
			"Europe/Sofia": "(GMT+3:00) Sofia",
			"Europe/Istanbul": "(GMT+3:00) Istanbul",
			"Europe/Athens": "(GMT+3:00) Athens",
			"Europe/Bucharest": "(GMT+3:00) Bucharest",
			"Asia/Nicosia": "(GMT+3:00) Nicosia",
			"Asia/Beirut": "(GMT+3:00) Beirut",
			"Asia/Damascus": "(GMT+3:00) Damascus",
			"Asia/Jerusalem": "(GMT+3:00) Jerusalem",
			"Asia/Amman": "(GMT+3:00) Amman",
			"Europe/Moscow": "(GMT+3:00) Moscow",
			"Asia/Baghdad": "(GMT+3:00) Baghdad",
			"Asia/Kuwait": "(GMT+3:00) Kuwait",
			"Asia/Riyadh": "(GMT+3:00) Riyadh",
			"Asia/Bahrain": "(GMT+3:00) Bahrain",
			"Asia/Qatar": "(GMT+3:00) Qatar",
			"Asia/Aden": "(GMT+3:00) Aden",
			"Africa/Djibouti": "(GMT+3:00) Djibouti",
			"Africa/Mogadishu": "(GMT+3:00) Mogadishu",
			"Europe/Kiev": "(GMT+3:00) Kiev",
			"Europe/Minsk": "(GMT+3:00) Minsk",
			"Asia/Dubai": "(GMT+4:00) Dubai",
			"Asia/Muscat": "(GMT+4:00) Muscat",
			"Asia/Baku": "(GMT+4:00) Baku, Tbilisi, Yerevan",
			"Asia/Tehran": "(GMT+4:30) Tehran",
			"Asia/Kabul": "(GMT+4:30) Kabul",
			"Asia/Yekaterinburg": "(GMT+5:00) Yekaterinburg",
			"Asia/Tashkent": "(GMT+5:00) Islamabad, Karachi, Tashkent",
			"Asia/Calcutta": "(GMT+5:30) India",
			"Asia/Kolkata": "(GMT+5:30) Mumbai, Kolkata, New Delhi",
			"Asia/Colombo": "(GMT+5:30) Asia/Colombo",
			"Asia/Kathmandu": "(GMT+5:45) Kathmandu",
			"Asia/Almaty": "(GMT+6:00) Almaty",
			"Asia/Dacca": "(GMT+6:00) Dacca",
			"Asia/Dhaka": "(GMT+6:00) Astana, Dhaka",
			"Asia/Rangoon": "(GMT+6:30) Rangoon",
			"Asia/Novosibirsk": "(GMT+7:00) Novosibirsk",
			"Asia/Krasnoyarsk": "(GMT+7:00) Krasnoyarsk",
			"Asia/Bangkok": "(GMT+7:00) Bangkok",
			"Asia/Saigon": "(GMT+7:00) Vietnam",
			"Asia/Jakarta": "(GMT+7:00) Jakarta",
			"Asia/Irkutsk": "(GMT+8:00) Irkutsk, Ulaanbaatar",
			"Asia/Shanghai": "(GMT+8:00) Beijing, Shanghai",
			"Asia/Hong_Kong": "(GMT+8:00) Hong Kong SAR",
			"Asia/Taipei": "(GMT+8:00) Taipei",
			"Asia/Kuala_Lumpur": "(GMT+8:00) Kuala Lumpur",
			"Asia/Singapore": "(GMT+8:00) Singapore",
			"Australia/Perth": "(GMT+8:00) Perth",
			"Asia/Yakutsk": "(GMT+9:00) Yakutsk",
			"Asia/Seoul": "(GMT+9:00) Seoul",
			"Asia/Tokyo": "(GMT+9:00) Osaka, Sapporo, Tokyo",
			"Australia/Darwin": "(GMT+9:30) Darwin",
			"Australia/Adelaide": "(GMT+9:30) Adelaide",
			"Asia/Vladivostok": "(GMT+10:00) Vladivostok",
			"Pacific/Port_Moresby": "(GMT+10:00) Guam, Port Moresby",
			"Australia/Brisbane": "(GMT+10:00) Brisbane",
			"Australia/Sydney": "(GMT+10:00) Canberra, Melbourne, Sydney",
			"Australia/Hobart": "(GMT+10:00) Hobart",
			"Asia/Magadan": "(GMT+11:00) Magadan",
			"SST": "(GMT+11:00) Solomon Islands",
			"Pacific/Noumea": "(GMT+11:00) New Caledonia",
			"Asia/Kamchatka": "(GMT+12:00) Kamchatka",
			"Pacific/Fiji": "(GMT+12:00) Fiji Islands, Marshall Islands",
			"Pacific/Auckland": "(GMT+12:00) Auckland, Wellington",
			"Pacific/Apia": "(GMT+13:00) Independent State of Samoa"
		};

		this.timezone_list = [];

		this.timezone_list = Object.keys(timeZonesObject).map(key => {
			return { value: key, name: `${key} : ${timeZonesObject[key]}` };
		});

	}

	min_amount_error: boolean = false;
	min_amount_error_text: any = "";
	checkAmountValidation(product, amount) {
		if (product != "" && product != null) {
			const index = this.product_list.findIndex((x) => x.id == product);

			if (index != -1) {
				const product = this.product_list[index];

				const product_min_amount = parseInt(product.min_balance_required);
				let aum: any = 0;
				if (amount != "" && amount != null) {
					aum = parseInt(amount);
				} else {
					aum = 0;
				}

				if (product_min_amount > aum) {
					this.min_amount_error = true;
					this.min_amount_error_text = "Amount Should be Greater than or Equal to " + product_min_amount;
				} else {
					this.min_amount_error = false;
					this.min_amount_error_text = "";
				}
			} else {
				this.min_amount_error = false;
				this.min_amount_error_text = "";
			}

		}
	}

	validateMaxValue(event, max_value): boolean {
		const charCode = event.which ? event.which : event.keyCode;

		// Allow only numeric input and the decimal point
		if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}

		// Get the current value of the input field
		const inputElement = event.target as HTMLInputElement;
		const currentValue = inputElement.value;

		// Check if the input value, when modified, would exceed 100
		const newValue = currentValue + String.fromCharCode(charCode);

		if (newValue !== '.' && parseFloat(newValue) > max_value) {
			return false;
		}

		return true;
	}

}
